import { Box, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import { Link, useParams } from "react-router-dom"
import styled from "styled-components"

import {
  ButtonLink,
  Content,
  LinkArrow,
  ReadmoreLink,
  SearchBox,
  SubTitle,
  Title,
  TitleBorder,
} from "areas/helpdesk/index"
import Loading from "areas/helpdesk/loading"
import fetchCollectionData from "hoc/helpdesk/fetch-collection-results"

import ExpandMenu from "./expandMenu"

const CollectionContainer = styled(Flex).attrs((props) => ({
  flexDirection: { _: "column", tablet: "inherit" },
  ...props.theme.helpdesk.collectionContainer,
}))``

const CollectionNavContainer = styled(Box).attrs((props) => ({
  flex: 1,
  my: 3,
  pt: 2,
  px: 1,
  textAlign: "left",
  ...props.theme.helpdesk.collectionNavContainer,
}))``

const Collection = ({ results }) => {
  const { collection_id: collectionId } = useParams()
  const collection = results[collectionId]

  if (
    !collection ||
    Object.keys(collection.categories).some(
      (catId) => collection.categories[catId].articles == false
    )
  ) {
    return <Loading />
  }

  return (
    <Box textAlign="center">
      <Helmet>
        <title>{collection.name}</title>
      </Helmet>
      <TitleBorder data-cy={`collection-${collection.name}`}>
        {collection.name}
      </TitleBorder>
      <CollectionContainer>
        <CollectionNavContainer>
          <ExpandMenu results={results} />
        </CollectionNavContainer>
        <Box flex={{ _: "1", tablet: "3" }} mb={{ _: 4, tablet: 6 }}>
          <Box mb={{ _: 5, tablet: 0 }}>
            {Object.keys(collection.categories).map((catId) => {
              const category = collection.categories[catId]

              if (Object.keys(category.articles).length === 0) return ""

              return (
                <Box key={`category-${catId}`}>
                  <Flex
                    addYPadding
                    flexDirection={{ _: "column", tablet: "inherit" }}
                    flexWrap="wrap"
                    gutter={{ _: 0, tablet: 2 }}
                    mb={2}
                  >
                    <Title my={3}>{category.name}</Title>

                    {Object.keys(category.articles)
                      .slice(0, 6)
                      .map((artId) => {
                        const article = category.articles[artId]
                        return (
                          <Box
                            display="flex"
                            flex="0 0 50%"
                            flexWrap="wrap"
                            key={`article-${artId}`}
                            minHeight={{ _: "160px", tablet: "300px" }}
                          >
                            <SearchBox
                              data-cy="helpdesk-collection-item"
                              my={{ _: 1, tablet: 0 }}
                              px={3}
                              py={4}
                            >
                              <Box height="90%">
                                <SubTitle
                                  as={Link}
                                  data-lc="collection"
                                  to={{
                                    pathname: `/helpdesk/a/${article.number}/${article.slug}`,
                                    state: {
                                      category: { id: catId, ...category },
                                    },
                                  }}
                                >
                                  {article.name}
                                </SubTitle>
                                <Content my={3}>
                                  {article.preview}
                                  {article.preview.length > 160 ? "..." : ""}
                                </Content>
                              </Box>

                              <ReadmoreLink
                                as={Link}
                                data-lc="collection"
                                to={{
                                  pathname: `/helpdesk/a/${article.number}/${article.slug}`,
                                  state: {
                                    category: { id: catId, ...category },
                                  },
                                }}
                              >
                                <Flex>
                                  <LinkArrow /> Keep Reading
                                </Flex>
                              </ReadmoreLink>
                            </SearchBox>
                          </Box>
                        )
                      })}
                  </Flex>
                  {Object.keys(category.articles).length > 6 && (
                    <ButtonLink
                      as={Link}
                      data-lc="collection"
                      to={`/helpdesk/${collectionId}/${catId}`}
                    >
                      SHOW MORE
                    </ButtonLink>
                  )}
                </Box>
              )
            })}
          </Box>
        </Box>
      </CollectionContainer>
    </Box>
  )
}

Collection.propTypes = {
  results: PropTypes.object,
}

export default fetchCollectionData(Collection)
